
import React, { useContext } from 'react'
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    CardFooter,
    Col,
    ListGroup,
    ListGroupItem,
    Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
    Row
} from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { SpinnerComponent } from 'react-element-spinner'

import AuctionTemplatesService from '../../services/AuctionTemplatesService'
import { SessionContext } from '../../contexts/SessionProvider'
import { VehiclesContext } from '../../contexts/VehiclesProvider'
import Paginator from '../../components/Paginator/Paginator'
import SiteService from '../../services/SiteService'
import {trigger} from '../../events/customEvents'
import { TemplatesContext } from '../../contexts/TemplatesProvider'

const SelectTemplateModal = ({ showSelectTemplateModal, selectedVehicle }) =>
{
    const [isModalBusy, setIsModalBusy] = React.useState(false)
    const sessionContext = useContext(SessionContext)
    const [pagingResult, setPagingResult] = React.useState({ pageCollection: [], totalRecords: 0 })
    const { t } = useTranslation()
    const vehiclesContext = useContext(VehiclesContext)
    const templatesContext = useContext(TemplatesContext)

    const retrieveAuctionTemplates = (pagingRequest) =>
    {
        setIsModalBusy(true)
        AuctionTemplatesService
            .getPagedTemplates(pagingRequest, sessionContext.loginSession.user.userSession.sessionKey)
            .then(result =>
            {
                setIsModalBusy(false)
                sessionContext.updateSession(result.data.loginSession)

                setPagingResult(result.data.actionResult)
            })
            .catch((error) =>
            {
                setIsModalBusy(false)
                SiteService.displayApiError(error)
            })
    }

    const handleOnOpened = () =>
    {
        retrieveAuctionTemplates(templatesContext.pagingRequest)
    }

    const handlePageChange = (e) =>
    {
        templatesContext.setPagingRequest((previousPagingRequest) =>
        {
            let currentPagingRequest = { ...previousPagingRequest }
            currentPagingRequest.pageIndex = e.pageIndex

            retrieveAuctionTemplates(currentPagingRequest)
            return currentPagingRequest
        })
    }

    const handleSelectTemplate = (e, template) =>
    {
        e.preventDefault()
        trigger('selectTemplateModalClosed', { adminAuctionId: template.adminAuctionId, vehicle: selectedVehicle })
    }

    const handleCancelModal = () =>
    {
        trigger('selectTemplateModalClosed', { adminAuctionId: undefined, vehicle: undefined })
    }

    return (
        <>
            <Modal
                isOpen={ showSelectTemplateModal }
                onOpened={ handleOnOpened }
				toggle={ () => handleCancelModal() }
            >
                <SpinnerComponent
                    loading={ isModalBusy }
                    position="centered"
                    color="#3578e5"
                    secondaryColor="#f3f3f3"
                    backgroundColor="#d3d3d3"
                    spinnerType="circle-dots"
                />
				<ModalHeader toggle={ () => handleCancelModal() } charCode="Y">
					Select Auction Template
				</ModalHeader>
                <ModalBody>
                    <Card>
                        <CardBody>
                            <ListGroup flush>
                                {
                                    pagingResult.pageCollection.map((pageItem, pgItemIdx) => (
                                        <ListGroupItem
											style={{
												cursor: 'pointer',
												borderWidth: '1px',
												borderStyle: 'solid',
												borderColor: 'black',
												padding: '5px'
											}}
											className="px-0"
											key={pgItemIdx}
										>
                                            <Row className="align-items-center">
                                                <Col xs={12} className="text-primary">
                                                    <div style={{marginLeft: '5px', cursor: 'pointer'}}>
                                                        <Button
                                                            block
															color="link"
                                                            style={{ paddingTop: '3px', paddingBottom: '3px' }}
                                                            size="lg"
                                                            type="button"
                                                            onClick={(e) => handleSelectTemplate(e, pageItem) }
                                                        >
                                                            <label style={{fontSize: '14px', cursor: 'pointer', marginBottom: '0px'}}>
                                                                { pageItem.name }
                                                            </label>
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </ListGroupItem>
                                    ))
                                }
                            </ListGroup>
                        </CardBody>
                        <CardFooter className="py-4">
                            {
                                (pagingResult.pageCollection.length > 0) && (
                                    <nav aria-label="...">
                                        <Paginator
                                            currentPage={ vehiclesContext.searchRequest.pageIndex }
                                            pages={ parseInt(((pagingResult.totalRecords - 1) / vehiclesContext.searchRequest.pageSize) + 1, 10) }
                                            selectPage={ handlePageChange }
                                        />
                                    </nav>
                                )
                            }
                        </CardFooter>
                    </Card>
                </ModalBody>
				<ModalFooter>
					<div className="text-center">
						<Button
							className="my-4"
							color="primary"
							type="button"
							size="sm"
							onClick={ () => handleCancelModal() }
						>
							{ t('Modals.PlaceMemberBid.Cancel') }
						</Button>
					</div>
				</ModalFooter>
            </Modal>
        </>
    )
}

export default SelectTemplateModal
